import { examComponentBase } from "../../../types";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./index.scss";



const ExamComponentInstructionsTile = ({examComponentBase} : {examComponentBase:examComponentBase[]}) => {
    
    

    return (

        <div className="outer-box">
            <h5>{examComponentBase[0].exam_component_title}</h5>
            <div style={{ whiteSpace: "pre-line" }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{examComponentBase[0].instructions}</ReactMarkdown>
            </div>
        </div>
    

    )
};

export default ExamComponentInstructionsTile;